import { useState } from 'react';
import './App.css';
import Header from './components/Header';
import Carousel from './components/Carousel';
import Brand from './components/Brand';
import slide from './assets/slide.png'
import OurService from './components/OurService';
import RepairService from './components/RepairService';
import OurStores from './components/OurStores';
import HotDeals from './components/HotDeals';
import { Toaster } from 'react-hot-toast';
import Slidebar from './components/Slidebar';
import Footer from './components/Footer';
import Login from './components/Login';
import Chat from './components/Chat';
import CallRequst from './components/callRequst';
import { FaArrowRight, FaPhoneAlt} from 'react-icons/fa';
import chat from './assets/icons/chat.png'


function App() {
  const [open, setOpen] = useState(false);
  const[login, setLogin] = useState(false)
  const[call, setCall] = useState(false)
  const slides = [
    <img src={slide} alt="Slide 1" />,
    <img src={slide} alt="Slide 2" />,
    <img src={slide} alt="Slide 3" />,
  ];
  return (
    <div className="bg-white relative ">
      <Toaster position="top-right" />
      <Header setLogin={setLogin} />
      <Carousel slides={slides} />
      <OurService />
      <RepairService />
      <OurStores />
      <HotDeals />
      <Slidebar />
      <Brand />
      <Footer setOpen={setOpen} setCall={setCall} />
      {/* {open ? (<div className='fixed bottom-6 right-6 z-40'>
        <Chat setOpen={setOpen} setLogin={setLogin} setCall={setCall} call={call} />
        </div>) : (<button class="fixed bottom-6 right-6 bg-teal-400 text-white px-4 py-3 rounded-md shadow-lg flex items-center space-x-2 cursor-pointer" onClick={() => setOpen(true)}>
        <img src={chat} alt="chat" />
        <div>
          <p class="font-semibold">Chat with Us</p>
          <p class="text-xs opacity-90">Got questions? Just ask.</p>
        </div>

        <FaArrowRight />
      </button>)} */}
      {/* {call ? (<div className='w-full fixed z-50 h-screen top-0 left-0 right-0 flex items-center justify-center bg-transparent backdrop-blur-lg'>
        <CallRequst setCall={setCall} />
        </div>) : (<button class="gap-2 fixed bottom-24 right-6 bg-teal-400 text-white px-4 py-3 rounded-full shadow-lg flex items-center justify-center cursor-pointer animate-bounce " onClick={() => setCall(true)}>
        <FaPhoneAlt  className='w-6 h-6' />
        <p>Request a Call</p>
      </button>)} */}


      {login && (<div className='w-full fixed z-50 h-screen top-0 left-0 right-0 flex items-center justify-center bg-transparent backdrop-blur-lg
      '><Login setLogin={setLogin} login={login}/></div>)}
      

    </div>
  );
}

export default App;
